import { useMemo } from 'react'
import { DataExplorerTable } from 'features/data-explorer/types'
import SubscriptionCard from 'features/data-observatory/ui/Subscriptions/SubscriptionCard'
import { ProcessingJob } from 'features/jobs/types'
import JobSuccessDownload from './JobSuccessDownload'
import { addDays } from 'date-fns'

interface JobSuccessProps {
  table: DataExplorerTable
  job: ProcessingJob
}

function JobSuccess({ table, job }: JobSuccessProps) {
  const downloadLinksAvailabilityDate = useMemo(() => {
    const creationTime = parseInt(job?.status?.provider?.statistics?.creationTime)
    return addDays(new Date(creationTime), 7)
  }, [job])

  return (
    <>
      <SubscriptionCard table={table} />
      <JobSuccessDownload availabilityDate={downloadLinksAvailabilityDate} job={job} />
    </>
  )
}

export default JobSuccess
